import { UPDATE_DARK_MODE, DarkModeActionTypes } from './../types/darkmode.type';

interface DarkModeState {
  isDarkMode: boolean,
}

const initialState: DarkModeState = {
  isDarkMode: false
};

export function darkModeReducer(state: DarkModeState = initialState, action: DarkModeActionTypes): DarkModeState {
  switch (action.type) {
    case UPDATE_DARK_MODE: {
      return {
        ...state,
        isDarkMode: action.payload,
      };
    }
    default:
      return state
  }
};